module.exports = __webpack_public_path__ + "img/student-progression-analytics.e915ebb5.png";